let contractJson = require('./AvalancheNFTTrading.json')

export default contractJson.abi;